import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '../../../core/i18n';
import { NotificationModule } from '../../../shared/components/notification/notification.module';
import { NoneAccountingCodesNotificationComponent } from './none-accounting-codes-notification.component';

@NgModule({
  declarations: [NoneAccountingCodesNotificationComponent],
  imports: [CommonModule, I18nModule, NotificationModule],
  exports: [NoneAccountingCodesNotificationComponent],
})
export class NoneAccountingCodesNotificationModule {}
